import { render, staticRenderFns } from "./CityAutoBuilding.vue?vue&type=template&id=6fbdc46f&"
import script from "./CityAutoBuilding.vue?vue&type=script&lang=js&"
export * from "./CityAutoBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports